// Copyright (C) 2021-Present CITEC Inc. <https://citecsolutions.com/>
// All rights reserved
//
// This file is part of CITEC Inc. source code.
// This software framework contains the confidential and proprietary information
// of CITEC Inc., its affiliates, and its licensors. Your use of these
// materials is governed by the terms of the Agreement between your organization
// and CITEC Inc., and any unauthorized use is forbidden. Except as otherwise
// stated in the Agreement, this software framework is for your internal use
// only and may only be shared outside your organization with the prior written
// permission of CITEC Inc.
// CITEC Inc. source code can not be copied and/or distributed without the express
// permission of CITEC Inc.

import { Typography } from '@mui/material';
import { Translation } from '@shared/ui-kit/providers';
import { defineComponent } from '@shared/ui-kit/utils/define-component';
import { DestinationFundItem } from '../destination-fund-item/destination-fund-item';
import { useDestinationFundsList } from './use-destination-funds-list';

export const DestinationFundsList = defineComponent({
  displayName: 'DestinationFundsList',
  useSetup: useDestinationFundsList,
  View: ({
    destinationFunds,
    currency,
    onDestinationFundPercentageChange,
    onDestinationFundAmountChange,
    onDestinationFundPercentageBlur,
    onDestinationFundAmountBlur,
    onRemoveDestinationFund,
  }) => (
    <div className="space-y-2">
      <Typography
        variant="subtitle2"
        className="!text-border-dark"
        gutterBottom
        sx={{ fontWeight: 'bold' }}
      >
        <Translation ns="components" i18nKey="ticker-modal.destination-funds" />
      </Typography>

      {destinationFunds.length > 0 && (
        <div className="max-h-48 overflow-y-auto pr-2">
          <div className="flex flex-col gap-2">
            {destinationFunds.map(fund => (
              <DestinationFundItem
                key={fund.id}
                fund={fund}
                onPercentageChange={(value: number) =>
                  onDestinationFundPercentageChange(fund.id, value)
                }
                onAmountChange={(value: number) =>
                  onDestinationFundAmountChange(fund.id, value)
                }
                onPercentageBlur={() => onDestinationFundPercentageBlur(fund.id)}
                onAmountBlur={() => onDestinationFundAmountBlur(fund.id)}
                onRemove={() => onRemoveDestinationFund(fund.id)}
                currency={currency}
              />
            ))}
          </div>
        </div>
      )}
    </div>
  ),
});
